import React from 'react'
import './index.css'

interface Props {
  title: string;
  backgroundColor?: string;
  disabled?: boolean;
	className?: string
  onPress?: () => void;
	type?: HTMLButtonElement['type'];

}

const BtnPrimary : React.FC<Props> = ({
	title = 'primary',
	backgroundColor,
	disabled = false,
	className,
	onPress = () => {},
	type
}) => {
	return (
		<>
			<button
				type={type || 'button'}
				disabled={disabled}
				className={`${disabled ? 'button-disabled' : 'button-primary'} ${className}`}
				style={{ backgroundColor: backgroundColor || undefined, borderWidth: 0 }}
				onClick={onPress}>

				<p>{title}</p>
				<div>
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path className={'svg-arrow-path'} d="M12.5625 5.25L19.3125 12L12.5625 18.75M18.375 12H4.6875" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
				</div>
			</button>
		</>

	// <div className='btn-primary-container' onClick={}>
	//   <p>{title}</p>
	// </div>
	)
}

export default BtnPrimary
